// @mui
import { styled } from '@mui/material/styles';
import {
    Grid,
    RadioGroup,
    CardActionArea,
    FormGroup,
    FormControlLabel,
    Switch,
    Box,
} from '@mui/material';
// hooks
import useSettings from '../../../hooks/useSettings';
import useLocales from '../../../hooks/useLocales';
//
import Iconify from '../../Iconify';
import BoxMask from './BoxMask';

// ----------------------------------------------------------------------

const BoxStyle = styled(CardActionArea)(({ theme }) => ({
    height: 72,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.disabled,
    border: `solid 1px ${theme.palette.grey[500_12]}`,
    borderRadius: Number(theme.shape.borderRadius) * 1.25,
}));

// ----------------------------------------------------------------------

type Props = {
    mini?: boolean;
};
export default function SettingMode({ mini }: Props) {
    const { translate } = useLocales();
    const { themeMode, onChangeMode } = useSettings();

    if (mini) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={themeMode === 'dark'}
                                onChange={(e) =>
                                    onChangeMode({
                                        target: { value: e.target.checked ? 'dark' : 'light' },
                                    } as any)
                                }
                            />
                        }
                        label={translate('components.settings.drawer.darkMode')}
                    />
                </FormGroup>
            </Box>
        );
    }

    return (
        <RadioGroup name="themeMode" value={themeMode} onChange={onChangeMode}>
            <Grid dir="ltr" container spacing={2.5}>
                {['light', 'dark'].map((mode, index) => {
                    const isSelected = themeMode === mode;
                    return (
                        <Grid key={mode} item xs={6}>
                            <BoxStyle
                                sx={{
                                    bgcolor: mode === 'light' ? 'common.white' : 'grey.800',
                                    ...(isSelected && {
                                        color: 'primary.main',
                                        boxShadow: (theme) => theme.customShadows.z20,
                                    }),
                                }}
                            >
                                <Iconify
                                    icon={index === 0 ? 'ph:sun-duotone' : 'ph:moon-duotone'}
                                    width={28}
                                    height={28}
                                />
                                <BoxMask value={mode} />
                            </BoxStyle>
                        </Grid>
                    );
                })}
            </Grid>
        </RadioGroup>
    );
}
